/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Description_TitleInputs */

const es_tyc_description_title = /** @type {(inputs: Tyc_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Descripcion del Servicio`)
};

const en_tyc_description_title = /** @type {(inputs: Tyc_Description_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Service Description`)
};

/**
* | output |
* | --- |
* | "2. Service Description" |
*
* @param {Tyc_Description_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_description_title = /** @type {((inputs?: Tyc_Description_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Description_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_description_title(inputs)
	return en_tyc_description_title(inputs)
});
export { tyc_description_title as "tyc.description.title" }